import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singlePet } from "redux-store/pets/pet.selector";
import { getSinglePet } from "redux-store/pets/pet.slice";
import { AppDispatch } from "redux-store/store";
import { test } from "redux-store/lab-tests/tests.selecter";
type Props = {
  handlePetModelClose?: any;
  open?: any;
  petId: any;
};
const SinglePetDetailModel = ({ handlePetModelClose, open, petId }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const pet = useSelector(singlePet);
  let tests = useSelector(test);
  useEffect(() => {
    if (petId) {
      dispatch(getSinglePet(petId));
    }
  }, [petId]);

  const matchedTest = tests?.find((t: any) => t.petId?._id === petId);
  function calculateAge(birthdate: any) {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let ageYears = today.getFullYear() - birthDate.getFullYear();
    let ageMonths = today.getMonth() - birthDate.getMonth();
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      ageYears--;
      ageMonths += 12;
    }
    return { years: ageYears, months: ageMonths };
  }
  return (
    <div>
      <Dialog
        open={open}
        onClose={handlePetModelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <div className="tw-flex tw-flex-col tw-gap-3 tw-py-10">
          <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
            <DialogTitle id="alert-dialog-title">{pet?.petName}</DialogTitle>
            <DialogContent className="no-scrollbar scroll_n">
              <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-2">
                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">Pet Breed</div>
                  <div>{pet?.petBreed}</div>
                </div>
                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">Pet Gender</div>
                  <div>{pet?.petGender}</div>
                </div>
                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">Pet Weight</div>
                  <div>{pet?.petWeight}</div>
                </div>
                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">Pet Age</div>
                  <div>{`${calculateAge(pet?.birthDate).years}y ${calculateAge(pet?.birthDate).months}m`}</div>
                </div>

                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">pet Birthdate</div>
                  <div className="tw-text-right">
                    <div>
                      {new Date(pet?.birthDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                      })}
                    </div>
                  </div>
                </div>

                <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                  <div className="tw-font-bold">Cancer Suspicion</div>
                  <div>{`${pet?.cancerSuspicion ? "YES" : "NO"}`}</div>
                </div>
                <div className="tw-flex">{pet?.medicalChart}</div>
              </div>
            </DialogContent>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SinglePetDetailModel;
